import React, { PureComponent } from "react";

import { Button, Dropdown, Icon, TileOptionsButton } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { ROLE_OPTIONS, ROLE_VALUES } from "containers/App/reducer";

import Select from "react-select";

import { Modal } from "react-bootstrap";

import styles from "./style.module.css";

export default class Collaborators extends React.Component {
  state = {
    sharingOptions: {}
  };
  render() {
    const {
      addUserRoleToSegment,
      deleteUserFromProject,
      patchUserRoleSegment,
      updateProjectSetting,
      project,
      users,
      userName,
      isLoadingSharing,
      show,
      onClick
    } = this.props;

    const { sharingOptions } = this.state;

    const roleOptions = ROLE_OPTIONS;

    return (
      <div className={styles.rightPanelBody + " " + (show ? styles.active : "")}>
        <div className={styles.rContent}>
          <div className={styles.rHeader}>{"Sharing and Permissions"}</div>
          <div className={styles.shareHolder}>
            {project &&
              project.segments &&
              project.segments.map((s, i) => {
                const subKey = s.id;

                const userKey = subKey + "-user";
                const roleKey = subKey + "-role";

                const roles = s.roles.filter((r) => s.conditions.length == 0 || r.role_type != "VIEWER");

                const sRoleOptions = roleOptions.filter(({ value }) => s.conditions.length == 0 || value != "VIEWER");

                const userRole =
                  s.roles.filter((r) => r.role_user.fullname === userName).length > 0
                    ? s.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                    : undefined;

                const overallRole =
                  project.roles && project.roles.filter((r) => r.role_user.fullname === userName).length > 0
                    ? project.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                    : undefined;

                return (
                  <div className={styles.shareItem} key={i}>
                    <div className={styles.rSubHeader}>
                      {s.name === ""
                        ? project.segments.length > 1 && userRole === "OWNER"
                          ? "Add to All Subgroups"
                          : "Overall"
                        : s.name
                          ? s.name.replace("@@_@@Other@@_@@", "Other")
                          : s.name}
                    </div>
                    {/*
                  <LineInput
                    isMediumBox
                    placeholder="Edit Description"
                  />
                  */}
                    {sharingOptions[subKey] && sharingOptions[subKey].isEdit ? (
                      <div className={styles.userEdit}>
                        {overallRole === "OWNER" &&
                          (isLoadingSharing ? (
                            <div className={styles.loadingShare}>
                              {"Adding user... "}
                              <LoadingIndicator style={{ margin: "0px", marginLeft: "20px" }} />
                            </div>
                          ) : (
                            <div className={styles.userItem} style={{ marginBottom: "20px" }}>
                              <div className={styles.userName} style={{ overflow: "visible" }}>
                                <Select
                                  options={
                                    users
                                      ? users
                                          .filter(
                                            (u) =>
                                              u.fullname === undefined ||
                                              userName === undefined ||
                                              u.fullname !== userName
                                          )
                                          .map((u) => ({
                                            label: u.fullname,
                                            value: u.id
                                          }))
                                      : []
                                  }
                                  ref={userKey}
                                />
                              </div>
                              <div className={styles.userRoleSelect}>
                                <Select options={sRoleOptions} defaultValue={sRoleOptions[0]} ref={roleKey} />
                              </div>
                              <Button
                                onClick={() => {
                                  addUserRoleToSegment(
                                    s.id,
                                    this.refs[userKey].state.value.value,
                                    this.refs[roleKey].state.value.value
                                  );

                                  this.refs[userKey].state.value = undefined;
                                  this.refs[roleKey].state.value = sRoleOptions[0];
                                }}
                              >
                                {"Invite"}
                              </Button>
                            </div>
                          ))}
                        {s.name === "" && project.segments.length > 1 ? (
                          <div />
                        ) : (
                          roles.map((r, i) => (
                            <div key={i} className={styles.userItem}>
                              <div className={styles.userName}>{r.role_user.fullname}</div>
                              {r.role_user.fullname === userName ? (
                                <div className={styles.lockedRole}>
                                  {r.role_type ? r.role_type.toLowerCase() : r.role_type}
                                </div>
                              ) : (
                                <div className={styles.uItem}>
                                  <div className={styles.userRoleSelect}>
                                    <Select
                                      options={sRoleOptions}
                                      defaultValue={ROLE_VALUES[r.role_type]}
                                      onChange={(val) => patchUserRoleSegment(r.id, val.value)}
                                    />
                                  </div>
                                  <Button onClick={() => deleteUserFromProject(r.role_user.id)}>{"Delete"}</Button>
                                </div>
                              )}
                            </div>
                          ))
                        )}
                        <Button
                          onClick={() =>
                            this.setState({
                              sharingOptions: {
                                ...sharingOptions,
                                [subKey]: {
                                  ...sharingOptions[subKey],
                                  isEdit: false
                                }
                              }
                            })
                          }
                        >
                          {"Done"}
                        </Button>
                      </div>
                    ) : s.name === "" && project.segments.length > 1 && userRole === "OWNER" ? (
                      <div>
                        <a
                          onClick={() =>
                            this.setState({
                              sharingOptions: {
                                ...sharingOptions,
                                [subKey]: {
                                  ...sharingOptions[subKey],
                                  isEdit: true
                                }
                              }
                            })
                          }
                        >
                          {"Add Users"}
                        </a>
                      </div>
                    ) : (
                      <div>
                        <span>{roles.length + " Collaborator" + (roles.length > 1 ? "s" : "")}</span>
                        {userRole === "OWNER" && (
                          <a
                            onClick={() =>
                              this.setState({
                                sharingOptions: {
                                  ...sharingOptions,
                                  [subKey]: {
                                    ...sharingOptions[subKey],
                                    isEdit: true
                                  }
                                }
                              })
                            }
                            style={{ marginLeft: "5px" }}
                          >
                            {"Edit"}
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
          <div className={styles.eFooter}>
            <Button onClick={() => onClick(false)}>{"Close Sharing"}</Button>
          </div>
        </div>
      </div>
    );
  }
}
